import React, { Component } from 'react';
import ProductCard from './product-card';

class ProductCards extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { products } = this.props;
    if (products.length === 0)
      return <p>Tyvärr finns inga implantat som uppfyller dessa kriterier</p>;
    else
      return (
        <div className="ui cards">
          {products.map((product, index) => (
            <ProductCard
              uniq={index}
              key={`item-${index}`}
              product={product}
              showImg={this.props.showImg}
            />
          ))}
        </div>
      );
  }
}

export default ProductCards;
